import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentCreator from './content-creator-model'
import {
  CreateContentCreatorAsync,
  DeleteContentCreatorAsync,
  LoadContentCreatorsAsync,
} from './contentCreator-thunk'
const initialState: contentCreatorSliceState = {
  contentCreator: [],
  selected_contentCreator: '',
  is_loading_contentCreator: false,
  is_creating_contentCreator: false,
  is_deleting_contentCreator: false,
}
export interface contentCreatorSliceState {
  contentCreator: ContentCreator[]
  selected_contentCreator?: string
  is_loading_contentCreator: boolean
  is_creating_contentCreator: boolean
  is_deleting_contentCreator: boolean
}
export const contentCreatorSlice = createSlice({
  name: 'contentCreator',
  initialState,
  reducers: {
    setSelectedcontentCreator: (state, action) => {
      state.selected_contentCreator = action.payload
    },
    clearStatecontentCreator: (state) => {
      state.contentCreator = []
      state.is_loading_contentCreator = false
      state.is_creating_contentCreator = false
      state.is_deleting_contentCreator = false
    },
    mergecontentCreator: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentCreator = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentCreator = merge(state.contentCreator, payload) as any
        }
      }
    },

    add_contentCreator: (state, action) => {
      if (action.payload) {
        state.contentCreator = [...state.contentCreator, action.payload]
      }
    },
    set_contentCreator: (state, action) => {
      let { key, value, id } = action.payload
      state.contentCreator = state.contentCreator.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentCreatorsAsync.pending, (state) => {
      state.is_loading_contentCreator = true
    })
    builder.addCase(LoadContentCreatorsAsync.fulfilled, (state, action) => {
      state.is_loading_contentCreator = false
      if (action.payload) {
        state.contentCreator = action.payload
      }
    })
    builder.addCase(LoadContentCreatorsAsync.rejected, (state) => {
      state.is_loading_contentCreator = false
    })
    builder.addCase(CreateContentCreatorAsync.pending, (state) => {
      state.is_creating_contentCreator = true
    })
    builder.addCase(CreateContentCreatorAsync.fulfilled, (state) => {
      state.is_creating_contentCreator = false
    })
    builder.addCase(CreateContentCreatorAsync.rejected, (state) => {
      state.is_creating_contentCreator = false
    })
    builder.addCase(DeleteContentCreatorAsync.pending, (state) => {
      state.is_deleting_contentCreator = true
    })
    builder.addCase(DeleteContentCreatorAsync.fulfilled, (state, action) => {
      state.is_deleting_contentCreator = false
      if (state.contentCreator) {
        state.contentCreator = state.contentCreator.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteContentCreatorAsync.rejected, (state) => {
      state.is_deleting_contentCreator = false
    })

    builder.addCase(autoThunks.store_new_content_creator.pending, (state) => {
      state.is_loading_contentCreator = true
    })
    builder.addCase(
      autoThunks.store_new_content_creator.fulfilled,
      (state, action) => {
        state.is_loading_contentCreator = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_new_content_creator.rejected, (state) => {
      state.is_loading_contentCreator = false
    })

    builder.addCase(autoThunks.get_content_creators.pending, (state) => {
      state.is_loading_contentCreator = true
    })
    builder.addCase(
      autoThunks.get_content_creators.fulfilled,
      (state, action) => {
        state.is_loading_contentCreator = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_content_creators.rejected, (state) => {
      state.is_loading_contentCreator = false
    })

    builder.addCase(
      autoThunks.load_my_content_house_content_crerator.pending,
      (state) => {
        state.is_loading_contentCreator = true
      },
    )
    builder.addCase(
      autoThunks.load_my_content_house_content_crerator.fulfilled,
      (state, action) => {
        state.is_loading_contentCreator = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_my_content_house_content_crerator.rejected,
      (state) => {
        state.is_loading_contentCreator = false
      },
    )
  },
})

function handleResult(action: any, state: contentCreatorSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentCreator = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentCreator = merge(state.contentCreator, payload) as any
    }
  }
}

export const {
  clearStatecontentCreator,
  setSelectedcontentCreator,
  set_contentCreator,
  mergecontentCreator,
  add_contentCreator,
} = contentCreatorSlice.actions

export const get_contentCreator =
  (id?: string) =>
  (state: {
    contentCreator: {
      contentCreator: ContentCreator[]
    }
  }): ContentCreator | null => {
    let temp = state?.contentCreator?.contentCreator?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.contentCreator?.contentCreator[0] || null
  }
export const get_selected_contentCreator = (state: {
  contentCreator: contentCreatorSliceState
}): ContentCreator | null => {
  let id = state?.contentCreator?.selected_contentCreator
  let temp = state?.contentCreator?.contentCreator?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentCreator = (state: {
  contentCreator: {
    contentCreator: ContentCreator[]
  }
}): ContentCreator[] => {
  let temp = state?.contentCreator?.contentCreator
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentCreator_busy = (state: {
  contentCreator: contentCreatorSliceState
}) => {
  return (
    state?.contentCreator.is_deleting_contentCreator ||
    state?.contentCreator.is_loading_contentCreator ||
    state?.contentCreator.is_creating_contentCreator
  )
}
export const is_deleting_contentCreator_busy = (state: {
  contentCreator: contentCreatorSliceState
}) => {
  return state?.contentCreator.is_deleting_contentCreator
}
export const is_loading_contentCreator_busy = (state: {
  contentCreator: contentCreatorSliceState
}) => {
  return state?.contentCreator.is_loading_contentCreator
}
export const is_creating_contentCreator_busy = (state: {
  contentCreator: contentCreatorSliceState
}) => {
  return state?.contentCreator.is_creating_contentCreator
}

export default contentCreatorSlice.reducer
